// import rightImg from "images/hero-right1.png";
import React, { FC } from "react";
import founder3Img from "images/founder/founder3.JPG";
import SectionStatistic from "./SectionStatistic";
import { Helmet } from "react-helmet-async";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import SectionHero from "./SectionHero";
import SectionClientSay from "components/SectionClientSay/SectionClientSay";
// import SectionPromo3 from "components/SectionPromo3";

export interface PageAboutProps {
  className?: string;
}

const PageAbout: FC<PageAboutProps> = ({ className = "" }) => {
  return (
    <div
      className={`nc-PageAbout overflow-hidden relative ${className}`}
      data-nc-id="PageAbout"
    >
      <Helmet>
        <title>About </title>
      </Helmet>

      {/* ======== BG GLASS ======== */}
      <BgGlassmorphism />

      <div className="container py-16 lg:py-28 space-y-16 lg:space-y-28">
        <SectionHero
          rightImg="https://www.tvs-e.in/wp-content/uploads/2023/02/TVSe-CCTV-Solutions.jpg"
          heading="Welcome to Meet Solution"
          btnText=""
          subHeading="We're impartial and independent, and every day we create distinctive, world-class programmes and content which inform, educate and entertain millions of people in the around the world."
        />

        {/* ======== ABOUT US CONTENT ======== */}
        <section className="prose prose-lg dark:prose-invert max-w-none">
          <h2 className="text-3xl lg:text-4xl font-semibold mb-6">About Us</h2>
          
          <p className="mb-4">
            Meet Solution Incorporation is a leading Wholesale Trader and trusted name in the field of security and surveillance solutions, headquartered in Surat, Gujarat, India. Since its establishment in 2016 (with operations dating back to 2014), the company has built a strong reputation for providing high-quality security products, cutting-edge technology, and reliable services across industries and homes alike.
          </p>

          <p className="mb-8">
            We specialize in a comprehensive range of CCTV products, including Bullet Cameras, Dome Cameras, IP Cameras, Wireless Cameras, DVR Racks, and more. Our product line extends to Biometric Attendance Systems, Digital Door Locks, Camera Cables, and a wide variety of related accessories, making us a one-stop destination for all surveillance and access control needs.
          </p>

          <h3 className="text-2xl lg:text-3xl font-semibold mb-4 mt-8">Our Product Categories</h3>
          
          <div className="mb-6">
            <h4 className="text-xl font-semibold mb-3">CCTV & Security Cameras:</h4>
            <p>Bullet Cameras (2MP, 3MP, etc.), Dome Cameras, Day/Night Cameras, Cube IP Cameras, Wireless Cameras, and Speed Dome PTZ Cameras.</p>
          </div>

          <div className="mb-6">
            <h4 className="text-xl font-semibold mb-3">Access Control & Attendance:</h4>
            <p>Biometric Attendance Systems (Fingerprint, Card, Password), Face Recognition Attendance Systems, Multi-Door Access Control, and Security Alarm Solutions.</p>
          </div>

          <div className="mb-6">
            <h4 className="text-xl font-semibold mb-3">Recording & Storage:</h4>
            <p>Complete CCTV Kits, Digital Video Recorders (DVRs), Network Video Recorders (NVRs), and DVR Racks.</p>
          </div>

          <div className="mb-8">
            <h4 className="text-xl font-semibold mb-3">Accessories & Peripherals:</h4>
            <p>CCTV Cat6 Cables, Copper Camera Cables, CCTV Power Supplies, Video Door Phones, Computer Accessories, Interactive Boards, and External Sounders.</p>
          </div>

          <h3 className="text-2xl lg:text-3xl font-semibold mb-4 mt-8">Our Services</h3>
          
          <p className="mb-8">
            We also provide professional CCTV Installation, Repair & Maintenance Services, and Annual Maintenance Contracts (AMCs) to ensure seamless security system performance and long-term reliability.
          </p>

          <p className="mb-8">
            At Meet Solution Incorporation, we believe in delivering innovative, affordable, and efficient surveillance solutions through our extensive wholesale network and dedicated customer service. Our goal is to make every home, business, and institution more secure with technology that inspires trust.
          </p>

          <h3 className="text-3xl lg:text-4xl font-bold mb-8 mt-12 text-center bg-gradient-to-r from-indigo-600 to-blue-600 bg-clip-text text-transparent">Founder Information</h3>
          
          {/* Founder Section with Images */}
          <div className="relative overflow-hidden bg-gradient-to-br from-indigo-50 via-white to-blue-50 py-16 px-8 md:px-16 rounded-3xl mb-12 shadow-2xl border border-indigo-100">
            {/* Decorative Elements */}
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-indigo-500 via-blue-500 to-indigo-500"></div>
            <div className="absolute top-4 right-4 w-20 h-20 bg-gradient-to-br from-indigo-100 to-blue-100 rounded-full opacity-50"></div>
            <div className="absolute bottom-4 left-4 w-16 h-16 bg-gradient-to-br from-blue-100 to-indigo-100 rounded-full opacity-50"></div>
            
            {/* Founder Name Heading */}
            <h2 className="text-4xl lg:text-5xl font-extrabold text-center mb-12 bg-gradient-to-r from-gray-800 via-indigo-800 to-gray-800 bg-clip-text text-transparent relative">
              Mr. Hitesh Jain
              <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-gradient-to-r from-indigo-500 to-blue-500 rounded-full"></div>
            </h2>
            
            {/* Founder Section - Image and Text Side by Side */}
            <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-center">
              {/* Founder Image */}
              <div className="flex-shrink-0">
                <div className="relative group">
                  <div className="relative bg-gradient-to-br from-white to-indigo-50 p-4 rounded-2xl shadow-2xl border-2 border-indigo-100 hover:border-indigo-300 transition-all duration-500 hover:shadow-3xl hover:-translate-y-2">
                    <div className="absolute inset-0 bg-gradient-to-br from-indigo-500/5 to-blue-500/5 rounded-2xl"></div>
                    <img
                      src={founder3Img}
                      alt="Mr. Hitesh Jain - Founder"
                      className="relative object-contain h-80 w-64 rounded-xl shadow-xl hover:shadow-2xl transition-all duration-500 hover:scale-105"
                    />
                    <div className="absolute -top-2 -right-2 w-6 h-6 bg-gradient-to-br from-indigo-500 to-blue-500 rounded-full shadow-lg"></div>
                    <div className="absolute -bottom-2 -left-2 w-4 h-4 bg-gradient-to-br from-blue-500 to-indigo-500 rounded-full shadow-lg"></div>
                  </div>
                </div>
              </div>

              {/* Founder Text Content */}
              <div className="flex-1">
                <div className="bg-white/90 backdrop-blur-sm p-8 rounded-2xl shadow-xl border border-indigo-100 relative overflow-hidden">
                  <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-indigo-500 via-blue-500 to-indigo-500"></div>
                  <div className="absolute top-4 right-4 text-4xl text-indigo-100 font-bold opacity-20">"</div>
                  <div className="absolute bottom-4 left-4 text-4xl text-blue-100 font-bold opacity-20">"</div>
                  
                  <p className="mb-6 text-gray-700 leading-relaxed text-lg font-medium relative z-10">
                    <span className="text-xl font-bold bg-gradient-to-r from-indigo-600 to-blue-600 bg-clip-text text-transparent">The Founder and Owner</span> of Meet Solution Incorporation, is a visionary entrepreneur with deep expertise in security and surveillance technology.
                  </p>

                  <p className="mb-0 text-gray-600 leading-relaxed text-base relative z-10">
                    With years of hands-on experience and a sharp understanding of market trends, he has guided the company to become a trusted name in wholesale security solutions. His leadership, commitment to quality, and focus on customer satisfaction continue to inspire the entire team to deliver excellence in every project.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="relative py-16">
          <BackgroundSection />
          <SectionClientSay />
        </div>

        <SectionStatistic />

        {/* <SectionPromo3 /> */}
      </div>
    </div>
  );
};

export default PageAbout;
